export const SearchImage = (second) => {
  return (
    <svg
      width="86"
      height="86"
      viewBox="0 0 86 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="86" height="86" fill="white" />
      <path
        d="M33.151 58.2486C19.2855 58.2486 8 46.9858 8 33.1312C8 19.2766 19.2855 8 33.151 8C47.0165 8 58.302 19.2766 58.302 33.1312C58.2882 46.9858 47.0165 58.2486 33.151 58.2486ZM33.151 13.6935C22.4311 13.6935 13.698 22.406 13.698 33.1312C13.698 43.8427 22.4173 52.569 33.151 52.569C43.8709 52.569 52.6041 43.8564 52.6041 33.1312C52.5903 22.406 43.8709 13.6935 33.151 13.6935Z"
        fill="#E5E5E5"
      />
      <path
        d="M50.8992 46.8955L46.8702 50.9213L54.2941 58.3394L58.3231 54.3136L50.8992 46.8955Z"
        fill="#E5E5E5"
      />
      <path
        d="M62.1375 53.2445L76.8307 67.9262C78.3898 69.4839 78.3898 72.0067 76.8307 73.5645L73.561 76.8317C72.002 78.3894 69.4772 78.3894 67.9182 76.8317L53.2387 62.15C51.6797 60.5922 51.6797 58.0694 53.2387 56.5116L56.5085 53.2445C58.0537 51.7005 60.5785 51.7005 62.1375 53.2445Z"
        fill="#E5E5E5"
      />
    </svg>
  );
};
